import React from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const ModalHostingNoDomain = ({ show, onHide, onConfirm, onCancel, hostingPids = [] }) => {
  
  // Function to get message based on hosting PIDs
  const getMessageByPids = (pids) => {
    // Check for specific PID groups
    const hasGroup1 = pids.some(pid => [1124, 1125].includes(pid));
    const hasGroup2 = pids.some(pid => [1126, 1127].includes(pid));
    const hasGroup3 = pids.some(pid => [1128, 1129, 1130, 1131].includes(pid));
    const hasGroup4 = pids.some(pid => [1132, 1133, 1134, 1135].includes(pid));
    const hasGroup5 = pids.some(pid => [1136, 1137, 1138, 1139, 1140, 1141, 1142, 1143].includes(pid));

    if (hasGroup1) {
      return "Dapatkan domain .MY.ID atau .BIZ.ID GRATIS* untuk website kamu, setelah melakukan pembayaran.";
    } else if (hasGroup2 || hasGroup4 || hasGroup5) {
      return "Setelah pembayaran, Kamu bisa klaim diskon hingga Rp200.000 untuk domain apa saja.";
    } else if (hasGroup3) {
      return "Dapatkan domain .MY.ID, .BIZ.ID atau .OR.ID GRATIS* untuk website kamu, setelah melakukan pembayaran.";
    }
    
    // Default message
    return "Setelah pembayaran, Kamu bisa klaim diskon hingga Rp200.000 untuk domain apa saja.";
  };

  // Function to get button text based on hosting PIDs
  const getButtonText = (pids) => {
    const buttonTexts = [
      "Beli Hosting Tanpa Domain",
      "Lanjut Hosting Dulu, Domain Nanti", 
      "Lanjut Tanpa Domain",
      "Atur Domain Nanti"
    ];
    
    // Random selection or can be based on PID logic
    const index = pids.length > 0 ? pids[0] % buttonTexts.length : 0;
    return buttonTexts[index];
  };

  const message = getMessageByPids(hostingPids);
  const buttonText = getButtonText(hostingPids);

  // Handle cancel button click
  const handleCancel = () => {
    onHide();
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="modal-hosting-no-domain"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="modal-hosting-no-domain" className="d-flex align-items-center" style={{ fontSize: "1.1rem", whiteSpace: "nowrap" }}>
          <FontAwesomeIcon icon={faBell} className="text-warning me-2" />
          <span>Lanjut Beli Hosting Tanpa Domain?</span>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="text-center py-3">
          <p className="mb-0" style={{ fontSize: "16px", lineHeight: "1.5" }}>
            {message}
          </p>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="justify-content-center">
        <div className="d-flex gap-3 w-100">
          <button
            className="btn btn-outline-secondary flex-fill rounded-5"
            onClick={handleCancel}
            style={{ fontWeight: "500" }}
          >
            Tidak
          </button>
          <button
            className="btn btn-cta flex-fill rounded-5"
            onClick={onConfirm}
            style={{ fontWeight: "600" }}
          >
            {buttonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHostingNoDomain; 